// extracted by mini-css-extract-plugin
module.exports = {"root":"_ePwJ","overlay":"jtB8x","container":"_1ul5G","success":"_14_1U","close":"_2QDFq","title":"_1f8f-","text":"GeD8L","input":"_3_wJk","submit":"rLjbw","textarea":"_1wEKo"};